export const BOTTOM = 'bottom';
export const TOP = 'top';
export const CENTER = 'center';
export const DESKTOP_BOTTOM_OFFSET = 20;
export const IOS_BOTTOM_OFFSET = 50;
